
module.exports = {
    // 路由前缀
    routePre: '/',
    // 路由模式，可选值为 history 或 hash
    routerMode: 'hash',
    //标题 （包括初次加载雪花屏的标题 页面的标题 浏览器的标题）
    title: 'system',
    // token名称
    tokenName: 'accessToken',
    //token存储位置localStorage sessionStorage, cookie
    storage: 'cookie',
    //加载时显示文字
    loadingText: '正在加载中...',
    // 弹窗显示时间
    messageDuration: 3000,
    // 默认打开的首页的路由name值，默认为home
    homeName: 'home_index',
    // 数据数量
    list_rows: 20,
    // aesKey
    aesKey: 'uM6kR6yG9xJ4fI4m',
    // 验证码有效时间
    verifyTime: 60,
    // 授权有效时间
    authTime: 3
}